<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Facility Settings">Facility Settings</span>
      </div>
      <div class="app-toolbar-end">
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="facilitysettings"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div class="settings-container">

          <mat-accordion multi="true" displayMode="flat">

            <!-- Section: Facility Rate Configuration -->
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">tune</mat-icon>
                  <span i18n="@@Rate Configuration">Rate Configuration</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@FacilityRateConfigDescription">Edit the shipping/handling rate configuration for this facility.</div>

              <ng-container *ngIf="facilityId">
                <app-rate-config-editor
                  subjectKind="facility"
                  [subjectId]="facilityId"
                  documentProperty="rateConfig"
                  editorMode="AUTHORITATIVE">
                </app-rate-config-editor>
              </ng-container>
            </mat-expansion-panel>

            <!-- Section: Facility Packing Rate Configuration
                 Parallel to the production rate configuration above; same
                 document shape, different evaluation inputs (per-package
                 rather than per-book). -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">inventory_2</mat-icon>
                  <span i18n="@@Packing Rate Configuration">Packing Rate Configuration</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@FacilityPackingRateConfigDescription">Edit the picking, packing and packaging rate configuration for this facility (what SnowfallPress pays the facility per packing operation).</div>

              <ng-container *ngIf="facilityId">
                <app-rate-config-editor
                  subjectKind="facility"
                  [subjectId]="facilityId"
                  documentProperty="packingRateConfig"
                  editorMode="AUTHORITATIVE">
                </app-rate-config-editor>
              </ng-container>
            </mat-expansion-panel>

          </mat-accordion>

        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>


